/* eslint-disable max-lines-per-function, max-lines */
import { EventBus, Events } from "jiffy-store";
import { api } from "jiffy-api";
import { scrollToElement } from "common/utils/ui/scroll";
import productMosaic from "components/jiffy/product-mosaic/product-mosaic";
import { initScroll as initSimilarProductsScroll } from "components/jiffy/product-details-similar-products/product-details-similar-products";
import initProductCards from "components/jiffy/product-card/product-card";
import { isCustomizableMadePage } from "components/jiffy/product-details/customizable-made-page-utils";
import initComparables from "components/jiffy/product-card-comparisons/product-card-comparisons";
import initSoftnessScore from "components/compositions/softness_score/component";
import { track } from "jiffy-analytics";
import { observeElementVisibility, isScrollOnTop } from "common/utils/ui/visibility";

import "./product-related-products.scss";

const CLASSES = {
  hiddenClass: "hidden",
  similarTabHandler: ".js-related-products-similar-handler",
  matchingTabHandler: ".js-related-products-matching-handler",
  handlerActive: "product-related-products__tabs-control--active",
  similarTab: ".js-related-products-similar-tab",
  matchingTab: ".js-related-products-matching-tab",
  tabActive: "product-related-products__tab--active"
};

let destroyProductMosaic;
let currentSlider;
const initProductMosaic = () => {
  if (destroyProductMosaic) {
    destroyProductMosaic();
  }

  destroyProductMosaic = productMosaic();
};

const updateComparablesProducts = async color => {
  const productDetails = document.querySelector(".js-product-details");
  const { altProductId, productId, reloadable, showComparables } = productDetails.dataset;
  const comparablesSpinners = document.querySelectorAll(".js-comparables-spinner");
  const mainWrappers = document.querySelectorAll(".js-related-comparables-products");
  let comparablesResponse = {};
  const pdpProductId = altProductId || productId;

  if (reloadable !== "true" || showComparables !== "true") return;

  mainWrappers.forEach(wrapper => wrapper.classList.remove(CLASSES.hiddenClass));
  const comparablesProductsBlocks = Array.from(
    document.querySelectorAll(".js-comparables-products")
  );
  comparablesSpinners.forEach(spinner => spinner.classList.remove(CLASSES.hiddenClass));

  try {
    comparablesResponse = await api.product.fetchSimilarProductsHtml(
      { productId: pdpProductId },
      { ac: color },
      { cacheable: true }
    );
  } catch (e) {
    console.log(e);
  }

  const useComparablesResponse =
    comparablesProductsBlocks.length > 0 &&
    comparablesResponse.html &&
    comparablesResponse.html.trim();

  EventBus.publish(Events.COMPARABLES_LOADED, this, { hasComparables: useComparablesResponse });

  if (useComparablesResponse) {
    setTimeout(() => {
      if (comparablesResponse.html) {
        comparablesProductsBlocks.forEach(block => {
          block.innerHTML = comparablesResponse.html; // eslint-disable-line no-param-reassign
        });
      }
      comparablesSpinners.forEach(spinner => spinner.classList.add(CLASSES.hiddenClass));
    }, 350);
    setTimeout(() => {
      comparablesProductsBlocks.forEach(block => block.classList.add("fade-in"));
    }, 360);
    setTimeout(() => {
      initComparables();
    }, 700);
    setTimeout(() => {
      comparablesProductsBlocks.forEach(block => {
        block.classList.remove("fade-in", "fade-out");
        initSimilarProductsScroll(block);
      });
    }, 710);
  } else {
    mainWrappers.forEach(wrapper => wrapper.classList.add(CLASSES.hiddenClass));
  }
};

const updateSimilarProducts = async color => {
  const spinners = document.querySelectorAll(".js-products-spinner");
  const similarProductsBlocks = Array.from(document.querySelectorAll(".js-similar-products"));
  const matchingProductsBlocks = Array.from(document.querySelectorAll(".js-matching-products"));
  const productsBlocks = [...similarProductsBlocks, ...matchingProductsBlocks];
  const mainWrappers = document.querySelectorAll(".js-related-products");
  const similarTabHandler = document.querySelectorAll(CLASSES.similarTabHandler);
  const matchingTabHandler = document.querySelectorAll(CLASSES.matchingTabHandler);
  const similarTabs = document.querySelectorAll(CLASSES.similarTab);
  const matchingTabs = document.querySelectorAll(CLASSES.matchingTab);

  const productDetails = document.querySelector(".js-product-details");
  const { altProductId, productId, reloadable } = productDetails.dataset;
  const pdpProductId = altProductId || productId;
  let similarResponse = {};
  let matchingResponse = {};

  if (reloadable !== "true") return;

  mainWrappers.forEach(wrapper => wrapper.classList.remove(CLASSES.hiddenClass));
  spinners.forEach(spinner => spinner.classList.remove(CLASSES.hiddenClass));
  similarTabHandler.forEach(handler => {
    handler.classList.add(CLASSES.hiddenClass, CLASSES.handlerActive);
  });
  similarTabs.forEach(wrapper => {
    wrapper.classList.add(CLASSES.hiddenClass, CLASSES.tabActive);
  });
  matchingTabHandler.forEach(handler => {
    handler.classList.add(CLASSES.hiddenClass);
    handler.classList.remove(CLASSES.handlerActive);
  });
  matchingTabs.forEach(wrapper => {
    wrapper.classList.add(CLASSES.hiddenClass);
    wrapper.classList.remove(CLASSES.tabActive);
  });
  productsBlocks.forEach(block => block.classList.add("fade-out"));

  if (similarProductsBlocks.length > 0) {
    try {
      similarResponse = await api.product.fetchSimilarProductsHtml(
        { productId: pdpProductId },
        { ac: color },
        { cacheable: true }
      );
    } catch (e) {
      console.log(e);
    }
  }
  if (matchingProductsBlocks.length > 0) {
    try {
      matchingResponse = await api.product.fetchMatchingProductsHtml(
        { productId: pdpProductId },
        { ac: color },
        { cacheable: true }
      );
    } catch (e) {
      console.log(e);
    }
  }

  const useSimilarResponse = similarProductsBlocks.length > 0 && similarResponse.html?.trim();
  const useMatchingResponse = matchingProductsBlocks.length > 0 && matchingResponse.html?.trim();

  if (useSimilarResponse || useMatchingResponse) {
    setTimeout(() => {
      if (useSimilarResponse) {
        similarTabs.forEach(wrapper => wrapper.classList.remove(CLASSES.hiddenClass));
        similarTabHandler.forEach(handler => {
          handler.classList.remove(CLASSES.hiddenClass);
        });
        similarProductsBlocks.forEach(block => {
          block.innerHTML = similarResponse.html; // eslint-disable-line no-param-reassign
        });
      }
      if (useMatchingResponse) {
        matchingTabs.forEach(tab => {
          tab.classList.remove(CLASSES.hiddenClass);
          if (!useSimilarResponse) {
            tab.classList.add(CLASSES.tabActive);
          }
        });
        matchingTabHandler.forEach(handler => {
          handler.classList.remove(CLASSES.hiddenClass);
          if (!useSimilarResponse) {
            handler.classList.add(CLASSES.handlerActive);
          }
        });
        matchingProductsBlocks.forEach(block => {
          block.innerHTML = matchingResponse.html; // eslint-disable-line no-param-reassign
        });
      }
      spinners.forEach(spinner => spinner.classList.add(CLASSES.hiddenClass));
      initProductMosaic();
      initSoftnessScore();
      $(".js-ships-tooltip").tooltip();
    }, 350);
    setTimeout(() => {
      productsBlocks.forEach(block => block.classList.add("fade-in"));
      initProductCards();
    }, 360);
    setTimeout(() => {
      productsBlocks.forEach(block => block.classList.remove("fade-in", "fade-out"));

      if (document.querySelector(".product-details-similar-products")) {
        currentSlider = initSimilarProductsScroll();
      }
    }, 710);
  } else {
    mainWrappers.forEach(wrapper => wrapper.classList.add(CLASSES.hiddenClass));
  }
};

const tabsToggles = () => {
  const similarTabHandlers = document.querySelectorAll(CLASSES.similarTabHandler);
  const matchingTabHandlers = document.querySelectorAll(CLASSES.matchingTabHandler);
  const similarTabs = document.querySelectorAll(CLASSES.similarTab);
  const matchingTabs = document.querySelectorAll(CLASSES.matchingTab);

  const similarHandlerEvent = () => {
    matchingTabHandlers.forEach(handler => handler.classList.remove(CLASSES.handlerActive));
    similarTabHandlers.forEach(handler => handler.classList.add(CLASSES.handlerActive));
    similarTabs.forEach(tab => tab.classList.add(CLASSES.tabActive));
    matchingTabs.forEach(tab => tab.classList.remove(CLASSES.tabActive));

    if (currentSlider) {
      currentSlider.reset();
    }
  };

  const matchingHandlerEvent = () => {
    matchingTabHandlers.forEach(handler => handler.classList.add(CLASSES.handlerActive));
    similarTabHandlers.forEach(handler => handler.classList.remove(CLASSES.handlerActive));
    similarTabs.forEach(tab => tab.classList.remove(CLASSES.tabActive));
    matchingTabs.forEach(tab => tab.classList.add(CLASSES.tabActive));

    if (currentSlider) {
      currentSlider.reset();
    }
  };

  similarTabHandlers.forEach(handler => handler.addEventListener("click", similarHandlerEvent));
  matchingTabHandlers.forEach(handler => handler.addEventListener("click", matchingHandlerEvent));
};

const scrollToAnchor = () => {
  const match = window.location.hash.match(/#comparables/);
  if (!match) return;

  const $targesArray = Array.from(document.querySelectorAll(".js-related-products"));

  $targesArray.forEach($target => {
    if ($target.offsetParent === null) return; // I want to test DOM element for visibility
    scrollToElement($target, true);
  });
};

export default () => {
  if (isCustomizableMadePage()) return;

  const carouselThumbnails = document.querySelector(".js-carousel-thumbnails");
  const sliderWrapper = document.querySelector(".js-slider-wrapper");
  let initialColor = "";

  if (carouselThumbnails instanceof HTMLElement) {
    const { altColorName, colorName } = carouselThumbnails.dataset;
    initialColor = altColorName || colorName;
  } else if (sliderWrapper instanceof HTMLElement) {
    initialColor = sliderWrapper.dataset.colorName;
  }

  if (initialColor) {
    updateSimilarProducts(initialColor);
    updateComparablesProducts(initialColor);
    tabsToggles();

    EventBus.on(Events.PRODUCT_COLOR_SELECTED, (evt, { color }) => {
      updateSimilarProducts(color);
      updateComparablesProducts(color);
    });
  }

  if (isScrollOnTop()) {
    observeElementVisibility(
      ".js-related-products",
      (entries, scrolled) => {
        track("viewed_on_pdp", { target: "matching_products", scrolled });
      },
      { mobileOnly: true, once: true, observerOptions: { threshold: 0.5 } } // track when 50% of the element is on screen
    );

    observeElementVisibility(
      ".js-related-comparables-products",
      (entries, scrolled) => {
        track("viewed_on_pdp", { target: "similar_product_comparisons", scrolled });
      },
      { mobileOnly: true, once: true, observerOptions: { threshold: 0.5 } }
    );
  }

  window.addEventListener("load", scrollToAnchor);
};
